import React from "react";
import { Link, useLocation } from "react-router-dom";

const MenuItem = ({
  icon,
  label,
  url,
  onClick,
}: {
  icon: React.ReactNode;
  label: string;
  url: string;
  onClick?: () => void;
}) => {
  const location = useLocation();
  const isActive = location.pathname === url;

  return (
    <Link
      to={{
        pathname: url,
        search: `?pageTitle=${encodeURIComponent(label)}`,
      }}
      className="no-underline text-inherit"
      onClick={() => {
        onClick && onClick();
      }}
    >
      <div
        className={`flex gap-2 items-center px-3 py-2 rounded-lg cursor-pointer w-full ${
          isActive ? "bg-gray-200" : "hover:bg-gray-100"
        }`}
      >
        {icon}
        <span className="text-sm sm:text-base font-normal">{label}</span>
      </div>
    </Link>
  );
};
export default MenuItem;
